import { useEffect, useState } from 'react'

const ABFRAGE = '(prefers-reduced-motion: reduce)'

// Liest den Systemwunsch nach weniger Bewegung und folgt Änderungen zur Laufzeit.
export const usePrefersReducedMotion = () => {
    const [reduziert, setReduziert] = useState(() => window.matchMedia(ABFRAGE).matches)

    useEffect(() => {
        const medien = window.matchMedia(ABFRAGE)
        const folgen = (e) => setReduziert(e.matches)
        medien.addEventListener('change', folgen)
        return () => medien.removeEventListener('change', folgen)
    }, [])

    return reduziert
}
